export const SITE_LIST_GRID_PAGE_SIZE = 6;
export const SITE_LIST_GRID_PAGE_SIZES = [6, 12, 24, 30];

export const SITE_LIST_PAGE_SIZE = 5;
export const SITE_LIST_PAGE_SIZES = [5, 10, 15, 25];
